import Swiper from 'swiper';

export default function() {
  const readerVoiceSlider = document.querySelectorAll('.reader-voice');

  readerVoiceSlider.forEach((block) => {
    let swiper;

    function swiperInit() {
      if (swiper) return;
      const slider = block.querySelector('.swiper-container');

      const swiper = new Swiper(slider, {
        direction: 'horizontal',
        slidesPerView: 'auto',
        speed: 1000,
        pagination: {
          el: block.querySelector('.swiper-pagination'),
          type: 'bullets',
          clickable: 'true',
        },
        navigation: {
          nextEl: block.querySelector('.swiper-button-next'),
          prevEl: block.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          767: {
            slidesPerView: '2',
          },
          998: {
            pagination: false,
            navigation: false,
          }
        },
      });
    }

    if (window.innerWidth <= 998) {
      swiperInit();
    }

    window.addEventListener('widthResize', function() {
      if (window.innerWidth > 998) {
        if (!swiper) return;

        swiper.destroy();
        swiper = null;
      } else {
        swiperInit();
      }
    });    
  });
}